module.exports = __webpack_public_path__ + "static/media/original.9eefe762.png";